import StudioHeader from './StudioHeader';

export default StudioHeader;
